import { render, staticRenderFns } from "./Payload.vue?vue&type=template&id=8dca29ec&"
import script from "./Payload.vue?vue&type=script&lang=js&"
export * from "./Payload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports